module.exports = __webpack_public_path__ + "img/ico-memb.0fc30fb8.svg";